import {
  OffshoreEventType,
  OffshoreFormConfig,
  SectionTemplateItemConfig,
} from '@navstation-portal/reporting/data-model/offshore-report';
import { NavStatus } from '@navstation-portal/shared/data-model/ui';

export function createDefaultTemplate(resolver: () => NavStatus | undefined): SectionTemplateItemConfig[] {
  return [
    {
      tabId: 'operational',
      sectionId: 'reportOptions',
      label: 'Setup',
      navItems: [
        {
          id: 'eventSelection',
          label: 'Event Selection',
          statusResolver: resolver,
        },
        {
          id: 'operationSelection',
          fieldId: 'operationType',
          label: 'Type of operation',
        },
      ],
    },
  ];
}

export function createTemplateFromFormConfig(
  formConfig: OffshoreFormConfig,
  statusResolvers: Record<string, () => NavStatus | 'hidden' | undefined>,
  eventType?: OffshoreEventType
): SectionTemplateItemConfig[] {
  const result: SectionTemplateItemConfig[] = [];
  if (!eventType) return [];

  for (const [tabId, tabEntry] of Object.entries(formConfig.tabs)) {
    for (const [sectionId, sectionEntry] of Object.entries(tabEntry.sections)) {
      const navItems = Object.entries(sectionEntry.fields ?? {})
        .filter(([, fieldConfig]) => {
          return (
            (fieldConfig?.visible_types?.includes(eventType) && fieldConfig?.required_types?.includes(eventType)) ??
            false
          );
        })
        .map(([fieldId, fieldConfig]) => ({
          id: fieldId,
          label: fieldConfig.label ?? camelToLabel(fieldId),
          ...(statusResolvers[fieldId] ? { statusResolver: statusResolvers[fieldId] } : {}),
        }));

      if (navItems.length > 0) {
        result.push({
          tabId,
          label: sectionEntry.label ?? camelToLabel(sectionId),
          sectionId,
          navItems,
        });
      }
    }

    const requiredCustomNavItems = (tabEntry.customFields ?? [])
      .filter((field) => !!field.required)
      .map((field) => ({
        id: field.id,
        label: field.label ?? camelToLabel(field.id),
        ...(statusResolvers[field.id] ? { statusResolver: statusResolvers[field.id] } : {}),
      }));

    if (requiredCustomNavItems.length > 0) {
      result.push({
        tabId,
        label: camelToLabel(tabId),
        sectionId: 'dynamicSection',
        navItems: requiredCustomNavItems,
      });
    }
  }
  return result;
}

function camelToLabel(str: string): string {
  return str
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (s) => s.toUpperCase())
    .trim();
}
